// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1UJqC","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1w8B4","obliqueLine":"membershipbadge_obliqueLine__2ov0R"};